import { Box, Grid } from "@mui/material";
import AdjustIcon from "@mui/icons-material/Adjust";
import React from "react";
import "./SensorsMobStyle.css";
import sensorImg from "../../imgs/sensor.png";

import { Context } from "../LocalWrapper";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import cutEngSen from "../../imgs/sensors/cutEngImg.jpg";
import doorSen from "../../imgs/sensors/doorSensImg.jpg";
import seatBeltSen from "../../imgs/sensors/seatBeltSensImg.jpg";
import iBtnSen from "../../imgs/sensors/iBtnImg.jpg";
import panicSen from "../../imgs/sensors/panicImg.jpg";
import tempSen from "../../imgs/sensors/tempImg.jpg";

const sensorsImages = {
  cutEngSen: cutEngSen,
  doorSen: doorSen,
  seatBeltSen: seatBeltSen,
  iBtnSen: iBtnSen,
  panicSen: panicSen,
  tempSen: tempSen,
};

function SensorsMob() {
  const context = useContext(Context);
  const { t } = useTranslation();

  const sensorsDataTrns = t("sensorsData", { returnObjects: true });

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        minHeight: "70vh",
        p: 5,
      }}
      dir={context.dir}
    >
      <Box
        sx={{
          maxWidth: "100%",
          margin: "0px",
          paddingBottom: "20px",
          display: {
            xs: "flex",
            sm: "flex",
            md: "flex",
            lg: "none",
          },
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1 className="sensors-header2 oz-header">
          {t("sen_header1")} {"  "}
          {context.dir === "ltr" && (
            <span style={{ color: "var(--primary)" }}> & </span>
          )}
          {t("sen_header2")}
        </h1>
      </Box>

      <Grid
        item
        container
        spacing={3}
        alignItems="start"
        justifyContent="center"
        // sx={{ backgroundColor: "green" }}
      >
        {Object.entries(sensorsDataTrns).map(([key, sensor]) => (
          <Grid
            item
            xs={6}
            sm={6}
            md={4}
            lg={3}
            key={key}
            className="sensor-card-container"
          >
            <Box className="sensor-card">
              <Box
                sx={{
                  backgroundImage: `url(${sensorsImages[key]})`,
                  backgroundSize: "cover", // Ensures the image covers the Box
                  backgroundPosition: "center", // Centers the image
                  height: "200px", // Example height
                  width: "100%", // Example width
                }}
                className="sensor-card-img"
              ></Box>
              <Box className="sensor-card-content">
                <h3 className="oz-subtitle">{sensor.name}</h3>
                <p className="oz-paragraph">{sensor.det1}</p>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default SensorsMob;
